import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/icons/document-icon-black.svg'


const _hoisted_1 = { class: "content-section" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "h2 mb-3 text-center" }, "Rådgivningsdokument", -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"card card-feat\"><div class=\"card-body\"><div class=\"row\"><div class=\"col\"><h1 class=\"h2 mb-3 text-center\"> Du har inga rådgivningsdokument </h1></div></div></div></div>", 1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { key: 2 }
const _hoisted_9 = { class: "card card-feat" }
const _hoisted_10 = { class: "card-body" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Rådgivningsdokumentation ")
const _hoisted_14 = {
  key: 0,
  class: "badge rounded-pill bg-success"
}
const _hoisted_15 = { class: "row" }
const _hoisted_16 = { class: "col" }
const _hoisted_17 = { class: "row" }
const _hoisted_18 = { class: "col" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_20 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showAdvisoryDocuments())
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7)),
    (_ctx.showAdvisoryDocuments())
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.app.advisories, (advisory, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "p-2"
            }, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("h6", null, [
                        _hoisted_13,
                        (!advisory.isRead)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_14, "Nytt"))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, "Datum: " + _toDisplayString(_ctx.formatDate(advisory)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _hoisted_19,
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn ordna-button",
                        style: {"margin-left":"-25px"},
                        onClick: () => _ctx.downloadAdvisoryDocument(advisory)
                      }, " Ladda ner ", 8, _hoisted_20)
                    ])
                  ])
                ])
              ])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}